import React from 'react';
import { Button, Icon, Pdf, Status, Text } from '../../Atoms';
import { OrganismDocumentSended } from '../../Organisms';
import Test from '../../assets/pdf/test.pdf';
import moment from 'moment';
function TemplateDocumentSended(props) {
  return (
    <div className="template-scroll template-document-sended">
      <div className="container-title-send-doc">
        <Icon
          icon="SortTop"
          size="20px"
          className="icon-return"
          onClick={() => props.onReturn()}
        />
        <Text text="Documents envoyés" className="title-send-document" />
      </div>
      {props.state.step === 1 && (
        <div className="content-template-document-sended">
          <div className="container-status-document">
            <Status type="error" text="Non traité" />
          </div>
          {props.state.datePending.map((el, index) => (
            <OrganismDocumentSended
              title={`${props.user ? props.user?.firstName : ''} ${
                props.user ? props.user?.lastName : ''
              }`}
              subTitle={
                el.categoryName !== el.subCategoryName
                  ? `${el.categoryName} - ${el.subCategoryName}`
                  : `${el.categoryName}`
              }
              date={moment(el.datereception).format('DD/MM/YYYY')}
              onOpen={() => props.onOpen(el)}
              onDownload={() => props.onDowLoad(el)}
            />
          ))}
          <div className="container-status-document">
            <Status type="success" text="Traité" />
          </div>
          {props.state.dateResolved.map((el, index) => (
            <OrganismDocumentSended
              title={`${props.user ? props.user?.firstName : ''} ${
                props.user ? props.user?.lastName : ''
              }`}
              subTitle={
                el.categoryName !== el.subCategoryName
                  ? `${el.categoryName} - ${el.subCategoryName}`
                  : `${el.categoryName}`
              }
              date={moment(el.datereception).format('DD/MM/YYYY')}
              onOpen={() => props.onOpen(el)}
              onDownload={() => props.onDowLoad(el)}
            />
          ))}
        </div>
      )}
      {props.state.step === 2 && (
        <div className="content-template-document-sended">
          <div className="container-doc-sended-step2">
            <div className="container-doc-description-step2">
              <Text
                text={moment(props.state.documentSelected.datereception).format(
                  'DD/MM/YYYY'
                )}
                className="title-document-sended doc-text"
              />
              <Text
                text={`${props.user ? props.user?.firstName : ''} ${
                  props.user ? props.user?.lastName : ''
                }`}
                className="title-document-sended doc-text web-visibiluty"
              />
              <Text
                text={`${props.state.documentSelected.categoryName} - ${props.state.documentSelected.subCategoryName}`}
                className="subtitle-document-sended doc-text"
              />
            </div>
          </div>
          {props.file.mimeType === 'application/pdf' ? (
            <Pdf url={props.file.url} />
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center' }}>
              <img
                src={props.file.url}
                alt="Fichier"
                style={{ objectFit: 'contain', maxWidth: '100%' }}
              />
            </div>
          )}
          <div className="container-btn-downlond-doc">
            <Button
              text="Télécharger"
              onClick={() => props.onDowLoad(props.state.documentSelected)}
              className="btn-downlond-doc"
            />
          </div>
        </div>
      )}
    </div>
  );
}
export default TemplateDocumentSended;
